export const NOTIFICATION_ITEM_HEIGHT = '64px'
